<template>
    <div class="local-material-page">
        <layout>
            <template v-slot:content >
                 <local-material />
            </template>
        </layout>
    </div>
</template>

<style lang="less" scoped>
@import 'LocalMaterial';
</style>

<script>
import LocalMaterial from './LocalMaterial'
export default LocalMaterial
</script>
